(function (global) {
  "use strict";

  const MAX_SECTION_MM = 3000;
  const FLAT_DELIVERY_FEE_AUD = 79;

  // Source: perth_metro_postcodes (1).xlsx, supplied 16 August 2026.
  const PERTH_METRO_POSTCODES = new Set([
    "6000", "6003", "6004", "6005", "6006", "6007", "6008", "6009", "6010", "6011", "6012",
    "6014", "6015", "6016", "6017", "6018", "6019", "6020", "6021", "6022", "6023", "6024",
    "6025", "6026", "6027", "6028", "6030", "6031", "6032", "6036", "6038", "6050", "6051",
    "6052", "6053", "6054", "6055", "6056", "6057", "6058", "6059", "6060", "6061", "6062",
    "6063", "6064", "6065", "6066", "6069", "6070", "6071", "6072", "6073", "6074", "6076",
    "6081", "6082", "6100", "6101", "6102", "6103", "6104", "6105", "6106", "6107", "6108",
    "6109", "6110", "6111", "6112", "6147", "6148", "6149", "6150", "6151", "6152", "6153",
    "6154", "6155", "6156", "6157", "6158", "6159", "6160", "6162", "6163", "6164", "6166",
    "6167", "6168", "6169", "6170", "6171", "6172", "6173", "6174", "6175", "6176"
  ]);

  function normalisePostcode(value) {
    return String(value || "").replace(/\D/g, "").slice(0, 4);
  }

  function splitEvenly(totalLengthMm) {
    const total = Math.max(0, Math.round(Number(totalLengthMm) || 0));
    if (!total) return [];

    const sectionCount = Math.ceil(total / MAX_SECTION_MM);
    const baseLength = Math.floor(total / sectionCount);
    const remainder = total % sectionCount;

    return Array.from({ length: sectionCount }, function (_, index) {
      return baseLength + (index < remainder ? 1 : 0);
    });
  }

  function trackCountFrom(value) {
    return String(value || "").toLowerCase().includes("double") || Number(value) === 2 ? 2 : 1;
  }

  function getConfiguration(postcodeValue, enteredLengthMm, trackCountValue) {
    const postcode = normalisePostcode(postcodeValue);
    const enteredLength = Math.max(0, Math.round(Number(enteredLengthMm) || 0));
    const trackCount = trackCountFrom(trackCountValue);
    const validPostcode = /^\d{4}$/.test(postcode);
    const isPerthMetro = validPostcode && PERTH_METRO_POSTCODES.has(postcode);
    const isOutsidePerthMetro = validPostcode && !isPerthMetro;
    const sectionLengthsMm = enteredLength
      ? (isOutsidePerthMetro ? splitEvenly(enteredLength) : [enteredLength])
      : [];
    const joinersPerTrack = Math.max(0, sectionLengthsMm.length - 1);
    const longestSectionMm = sectionLengthsMm.length ? Math.max.apply(null, sectionLengthsMm) : 0;

    return {
      postcode,
      validPostcode,
      deliveryArea: !validPostcode ? "Postcode required" : (isPerthMetro ? "Perth Metro" : "Outside Perth Metro"),
      isPerthMetro,
      isOutsidePerthMetro,
      enteredLengthMm: enteredLength,
      trackCount,
      sectionLengthsMm,
      sectionsPerTrack: sectionLengthsMm.length,
      splitRequired: isOutsidePerthMetro && sectionLengthsMm.length > 1,
      joinersPerTrack,
      totalJoiners: joinersPerTrack * trackCount,
      longestSectionMm,
      deliveryFeeAud: FLAT_DELIVERY_FEE_AUD
    };
  }

  function sectionDescription(configuration) {
    const config = configuration;
    if (!config.validPostcode) return "";
    if (!config.enteredLengthMm) {
      return config.isPerthMetro
        ? "Your saved tracks can be delivered at their full ordered lengths. Australia-wide delivery is a flat A$79."
        : "Saved tracks longer than 3000mm will be supplied in balanced sections with the required joiners included. Australia-wide delivery is a flat A$79.";
    }

    if (!config.splitRequired) {
      return "Your " + config.enteredLengthMm + "mm track will be supplied as one full-length section. Australia-wide delivery is a flat A$79.";
    }

    const lengths = config.sectionLengthsMm.map(function (length) { return length + "mm"; }).join(" + ");
    return "Each track will be supplied as " + config.sectionsPerTrack + " balanced sections (" + lengths + ") with " + config.totalJoiners + " joiner" + (config.totalJoiners === 1 ? "" : "s") + " included. Track pricing remains based on the full " + config.enteredLengthMm + "mm ordered length, with flat A$79 Australia-wide delivery.";
  }

  function applyToCartItems(items, postcodeValue) {
    const output = JSON.parse(JSON.stringify(Array.isArray(items) ? items : []));

    output.forEach(function (item) {
      const properties = item && item.properties;
      if (!properties || properties["_Luxworld Studio Type"] !== "Curtain Track") return;

      const enteredLength = Number(String(properties["Entered Length"] || "").replace(/[^0-9.]/g, ""));
      const configuration = getConfiguration(postcodeValue, enteredLength, properties["Track Configuration"]);

      properties["Delivery Postcode"] = configuration.postcode;
      properties["Delivery Area"] = configuration.deliveryArea;
      properties["Track Sections Per Track"] = configuration.sectionLengthsMm.map(function (length) { return length + " mm"; }).join(" + ");
      properties["Joiners Included"] = String(configuration.totalJoiners);
      properties["Track Pricing Basis"] = configuration.enteredLengthMm + " mm full ordered length";
      properties["Delivery Fee"] = "A$79 Australia-wide flat rate";
    });

    // Remove legacy length-tier markers from requests made by an older cached builder.
    return output.filter(function (item) {
      return !(item && item.properties && item.properties["_Luxworld Shipping Marker"] === "true");
    });
  }

  global.LUX_CURTAIN_TRACK_DELIVERY_RULES = Object.freeze({
    maxSectionMm: MAX_SECTION_MM,
    perthMetroPostcodes: PERTH_METRO_POSTCODES,
    normalisePostcode,
    splitEvenly,
    getConfiguration,
    sectionDescription,
    applyToCartItems
  });
})(window);
